"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var v4_exports = {};
__export(v4_exports, {
  createThemes: () => import_theme_builder.createThemes,
  defaultThemes: () => import_generated_v4.themes,
  tamaguiThemes: () => import_generated_v4_tamagui.themes,
  tokens: () => import_v4_tokens.tokens
});
module.exports = __toCommonJS(v4_exports);
var import_v4_tokens = require("./v4-tokens");
var import_theme_builder = require("@tamagui/theme-builder");
var import_generated_v4_tamagui = require("./generated-v4-tamagui");
var import_generated_v4 = require("./generated-v4");
//# sourceMappingURL=v4.js.map
